<template>

    <transition name="fade">
    <div id="background" @click.stop="removePopup">

        <div id="popup" :class="{live: store.live}">
            <div id="close" :class="{live: store.live}"></div>
        <p>
        Thank you for supporting Montez Press Radio! Your subscription ended. If you want to listen to our archive please support us for another year. Your support makes Montez Press Radio possible.

        </p>
        <router-link :to="{name: 'subscribe'}">Support us for another year!</router-link>

    </div>
    </div>
    </transition>

</template>


<script>
import {store} from '../store'

export default{
    name: 'SubscriptionExpiredPopup',
    data(){
        return {
            store: store,
        }
    },
    methods:{
        removePopup(){
            this.store.showSubExpiredPopup = false;
        }

    },
}

</script>


<style scoped>
#background{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    backdrop-filter: blur(30px);
    background-color: rgba(255,255,255,0.4)
}
@-moz-document url-prefix() {
    #background {
        background-color: rgba(255,255,255,0.9) !important;
    }
}

#popup {
    background-color: #FCFAC4;
    position: fixed;
    top: 50%;
    left: 50%;
    padding: 6rem 20px;
    width: calc(100vw - 40px);
    height: calc(100vh - 12rem);
    transform: translate(-50%, -50%);
}
#popup.live {
    padding: 10rem 20px;
    height: calc(100vh - 20rem);
}
@media only screen and (min-width: 738px){
#popup, #popup.live {
    width: 60vw;
    height: auto;
    padding: 1rem 1.5rem;
}
}
@media only screen and (min-width: 1101px){
#popup, #popup.live {
    width: 30vw;
}
}

#close{
    position: absolute;
    right: 20px;
    top: 5rem;
    width: 13px;
    height: 15px;
    cursor: pointer;
}
#close.live{
    top: 9rem;
}
#close:before, #close:after {
    position: absolute;
    left: 6px;
    content: ' ';
    height: 17px;
    width: 1px;
    background-color: black;

}
#close:before {
      transform: rotate(45deg);

}
#close:after {
      transform: rotate(-45deg);

}
@media only screen and (min-width: 738px){
#close{
    display: none;
}
}
p{
    text-align: center;
}


a {
    border: 1px solid black;
    padding: 0.65rem 1rem 0.85rem;
    width: 100%;
    display: inline-block;
    box-sizing: border-box;
    text-align: center;

}
a:hover {
    background-color: black;
    color: #FCFAC4;
}

.fade-enter-active{
    transition: opacity .5s;
}
.fade-leave-active{
    transition: opacity .5s;
}

.fade-enter, .fade-leave-to{
    opacity: 0;
}


</style>
